import styled from "@emotion/styled";
import { useTheme, useMediaQuery } from "@mui/material";
import { DataGridPro, ptBR, DataGridProProps, GridToolbar } from "@mui/x-data-grid-pro";

const StyledGrid = styled(DataGridPro)`
    .MuiDataGrid-virtualScroller {
        min-height: 52px;
    }

    .row-color-danger {
        background-color: rgba(255, 0, 0, 0.2);
        
        :hover {
            background-color: rgba(255, 0, 0, 0.3);
        }
    }

    .row-color-reserved {
        background-color: rgba(128, 128, 128, 0.2);
        
        :hover {
            background-color: rgba(128, 128, 128, 0.3);
        }
    }
`;

export const Table = (props: DataGridProProps) => {
    const theme = useTheme();
    
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const isControlledPagination = props.paginationModel !== undefined;

    return (
        <StyledGrid
            localeText={{
                ...ptBR.components.MuiDataGrid.defaultProps.localeText,
                noRowsLabel: 'Não há registros'
            }}
            slots={{
                toolbar: isSmallScreen ? undefined : GridToolbar,
            }}
            rowSelection={false}
            {...props}
            pagination
            pageSizeOptions={props.pageSizeOptions ?? [10, 50, 100]}
            autoHeight
            initialState={isControlledPagination ? props.initialState : {
                ...props.initialState,
                pagination: { paginationModel: { page: 0, pageSize: 100 } },
              }}
            density={props.density ?? "compact"}
        />
    );
};
